import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { removeLeadingSlash } from "../helpers";
import type { HeaderNavLinks, ServiceLinksType } from "../types";

export const useHeaderNavLinks = (links: ServiceLinksType): HeaderNavLinks => {
  const { t } = useTranslation();
  return useMemo(() => {
    return links
      .map((link) => ({
        title: t(`header.${removeLeadingSlash(link)}`),
        path: link,
      }))
      .sort((a, b) => a.title.localeCompare(b.title));
  }, [links, t]);
};
